module.exports = __webpack_public_path__ + "img/case3.9a0bb587.png";